export default __webpack_public_path__ + "static/media/component.ba2279ed.svg";